import React from 'react';
import ErrorAlertContainer, { AlertVariant } from './ErrorAlertContainer';
import ErrorIcon from './ErrorIcon';
import styles from './ErrorAlert.module.scss';
import CloseButton from './CloseButton';

export default function ContentAlert(props: {
  contentText: React.ReactNode;
  dismissable: boolean;
  onDismissed?: () => void;
  variant?: AlertVariant;
}) {
  const content = React.isValidElement(props.contentText) ? (
    <div className={`${styles['title']} ${styles['text']}`}>
      {props.contentText}
    </div>
  ) : (
    <span className={`${styles['title']} ${styles['text']}`}>
      {props.contentText}
    </span>
  );

  return (
    <ErrorAlertContainer
      dismissable={props.dismissable}
      variant={props.variant}
    >
      <div>
        <ErrorIcon variant={props.variant} />
        {content}
        {props.dismissable ? <CloseButton onClick={props.onDismissed} /> : null}
      </div>
    </ErrorAlertContainer>
  );
}
